// extracted by mini-css-extract-plugin
module.exports = {"container":"SecondaryLayout_container__Mtplg"};